export default __webpack_public_path__ + "static/media/logoCPBlanco.d085eb3f.png";